export const CouponStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  EXCLUDED: 'EXCLUDED'
}

export const CouponStatusColors = {
  ACTIVE: 'var(--success)',
  INACTIVE: 'var(--danger)',
  EXCLUDED: 'var(--danger)'
}

export const getCouponStatusText = (status) => {
  switch (status.toUpperCase()) {
    case CouponStatus.ACTIVE:
      return 'Ativo'
    case CouponStatus.INACTIVE:
      return 'Inativo'
    case CouponStatus.EXCLUDED:
      return 'Excluído'
    default:
      return 'Não definido'
  }
}
